export interface SEOConfig {
  title: string;
  description: string;
  keywords?: string;
  ogImage?: string;
  canonical?: string;
  twitterCard?: "summary" | "summary_large_image";
}

export function updatePageSEO(config: SEOConfig) {
  // Update document title
  document.title = config.title;

  // Update or create meta description
  const updateMetaTag = (name: string, content: string, isProperty = false) => {
    const attribute = isProperty ? 'property' : 'name';
    let tag = document.querySelector(`meta[${attribute}="${name}"]`);
    
    if (!tag) {
      tag = document.createElement('meta');
      tag.setAttribute(attribute, name);
      document.head.appendChild(tag);
    }
    
    tag.setAttribute('content', content);
  };

  // Update primary meta tags
  updateMetaTag('title', config.title);
  updateMetaTag('description', config.description);
  
  if (config.keywords) {
    updateMetaTag('keywords', config.keywords);
  }

  // Update Open Graph tags
  updateMetaTag('og:title', config.title, true);
  updateMetaTag('og:description', config.description, true);
  
  if (config.ogImage) {
    updateMetaTag('og:image', config.ogImage, true);
  }

  if (config.canonical) {
    updateMetaTag('og:url', config.canonical, true);
    
    // Update canonical link
    let canonicalLink = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.href = config.canonical;
  }

  // Update Twitter tags
  updateMetaTag('twitter:card', config.twitterCard || 'summary_large_image');
  updateMetaTag('twitter:title', config.title);
  updateMetaTag('twitter:description', config.description);
  
  if (config.ogImage) {
    updateMetaTag('twitter:image', config.ogImage);
  }

  if (config.canonical) {
    updateMetaTag('twitter:url', config.canonical);
  }
}
